import { observer } from 'mobx-react'
import { getSnapshot } from 'mobx-state-tree'
import { GetServerSideProps } from 'next'
import React from 'react'

import { initializeStore, IStoreSnapshotIn } from '../models/Store'
import { getFeatureFlags } from '../helpers/getFeatureFlags'
import { Root } from '../components'

type Props = {
  initialState?: IStoreSnapshotIn
}

export default observer<React.FC>(function Home() {
  return <Root />
})

export const getServerSideProps: GetServerSideProps<Props> = async (
  context
) => {
  const { query } = context

  const features = await getFeatureFlags()
  const store = initializeStore({ features })

  return { props: { initialState: getSnapshot(store), query } }
}
